import React from "react";
import PropTypes from "prop-types";
import { useTimeZoneStore } from "../../stores/timeZone";
import { parseDate } from "../../utils/timeZone";
import SoftTypography from "../SoftTypography";

/** Displays a table timestamp as a date above a smaller time, including seconds. */
const CreatedTime = ({ value }) => {
  const timeZone = useTimeZoneStore((state) => state.timeZone);
  const date = parseDate(value).tz(timeZone);
  if (!date.isValid()) return value || null;

  return (
    <SoftTypography component="time" dateTime={date.toISOString()} variant="caption">
      <SoftTypography component="span" variant="caption" sx={{ display: "block", lineHeight: 1.4 }}>
        {date.format("DD MMM YYYY")}
      </SoftTypography>
      <SoftTypography
        component="span"
        variant="caption"
        color="secondary"
        sx={{ display: "block", fontFamily: '"DM Mono", monospace', fontSize: 12.5, mt: 0.375 }}
      >
        {date.format("HH:mm:ss")}
      </SoftTypography>
    </SoftTypography>
  );
};

CreatedTime.propTypes = {
  value: PropTypes.string,
};

export default CreatedTime;
